import React, { useEffect, forwardRef, useState } from 'react';
import Reload from '../Assets/reload-svgrepo-com.svg';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import * as XLSX from "xlsx";

const ResultPage = forwardRef(({handleStatus, handleRowClick, Data, MockJson}, ref) => {

    const [highlightedRow, setHighlightedRow] = useState('');
    const [disabledBtn, setDisabledBtn] = useState(true);
    const [rows, setRows] = useState([]);

    const handleClick = () => {
        // handleStatus(false)
    }

    const handleOnClick = (value, rowId, indexId) => {
        if (handleRowClick) {
          handleRowClick(value, rowId, indexId); 
        }
        setHighlightedRow(indexId)
    };

    // const flattenObject = (obj, parentKey = "") => {
    //   let rows = [];

    //   Object.entries(obj).forEach(([key, value]) => {
    //     const fullKey = parentKey ? `${parentKey}.${key}` : key;

    //     if (value && typeof value === "object" && !Array.isArray(value)) {
    //       rows = rows.concat(flattenObject(value, fullKey));
    //     } else {
    //       rows.push({
    //         id: fullKey,      // stable & unique
    //         key: fullKey,
    //         value: value ?? "-"
    //       });
    //     }
    //   });

    //   return rows;
    // };

    const flattenObject = (data, parentKey = "") => {
      let rows = [];

      if (Array.isArray(data)) {
        data.forEach((item, index) => {
          const arrayKey = parentKey ? `${parentKey}[${index}]` : `[${index}]`;
          rows = rows.concat(flattenObject(item, arrayKey));
        });
        return rows;
      }

      if (data && typeof data === "object") {
        Object.entries(data).forEach(([key, value]) => {
          const fullKey = parentKey ? `${parentKey}.${key}` : key;
          rows = rows.concat(flattenObject(value, fullKey));
        });
        return rows;
      }

      rows.push({
        id: parentKey,
        key: parentKey,
        value: data ?? "-"
      });

      return rows;
    };


    // const agreement = MockJson.extracted_data.agreement;
    // const rows = flattenObject(agreement);

    useEffect(() => {
      if (Data?.extracted_data) {
        setRows(flattenObject(Data.extracted_data));
      }
    }, [Data]);


    // const unflattenObject = (rows) => {
    //   const result = {};

    //   rows.forEach(({ key, value }) => {
    //     const keys = key.split(".");
    //     let current = result;

    //     keys.forEach((k, index) => {
    //       if (index === keys.length - 1) {
    //         current[k] = value;
    //       } else {
    //         if (!current[k]) current[k] = {};
    //         current = current[k];
    //       }
    //     });
    //   });

    //   return result;
    // };

    const unflattenObject = (rows) => {
      const result = {};

      rows.forEach(({ key, value }) => {
        const parts = key.split(".");
        let current = result;

        parts.forEach((part, index) => {
          const arrayMatch = part.match(/(.*)\[(\d+)\]/);

          if (arrayMatch) {
            const [, arrayKey, arrayIndex] = arrayMatch;

            if (!current[arrayKey]) current[arrayKey] = [];
            if (!current[arrayKey][arrayIndex]) current[arrayKey][arrayIndex] = {};

            if (index === parts.length - 1) {
              current[arrayKey][arrayIndex] = value;
            } else {
              current = current[arrayKey][arrayIndex];
            }
          } else {
            if (index === parts.length - 1) {
              current[part] = value;
            } else {
              if (!current[part]) current[part] = {};
              current = current[part];
            }
          }
        });
      });

      return result;
    };


    const handleSave = () => {
      const updatedAgreement = unflattenObject(rows);

      const updatedMockJson = {
        ...Data,
        extracted_data: {
          ...Data.extracted_data,
          agreement: updatedAgreement
        }
      };

      console.log("UPDATED JSON:", updatedMockJson);

      setDisabledBtn(true);

      // send updatedMockJson to API here
    };

    const getExportData = () =>
      rows.map((row) => ({
        Entity: row.key?.split(".")?.pop(),
        Value: row.value,
        Page: 1
      }));

    const exportExcel = () => {
      const worksheet = XLSX.utils.json_to_sheet(getExportData());
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Extracted Values");

      XLSX.writeFile(workbook, "Extracted_Values.xlsx");
    };

    const exportCSV = () => {
      const worksheet = XLSX.utils.json_to_sheet(getExportData());
      const csv = XLSX.utils.sheet_to_csv(worksheet);

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Extracted_Values.csv";
      link.click();
    };

    const getFormattedDate = () => {
      const today = new Date();

      return today.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
    };



  return (
    <div className="d-flex flex-wrap" style={{ height: "100%", width: "100%" }} >
      <div className="" style={{ height: "100%", width: "100%" }}>
        <div
          className="ps-1"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: 'center',
            width: "100%",
            height: "12%",
          }}
        >
          <p
            className="text-start mb-0"
            style={{ fontSize: "14.5px", fontWeight: "500", color: '#000' }}
          >
            {/* {`Extracted Values (${Data.process_result && Data.process_result.length})`} */}
            {`Extracted Values (${rows.length})`}
          </p>
          <div style={{display: "flex"}}>
            <OverlayTrigger
                key="left"
                placement="left"
                overlay={
                    <Tooltip id="tooltip-left">
                        <p className='mb-0'>Regenerate</p>
                    </Tooltip>
                    }
            >
                <img
                    src={Reload}
                    style={{ width: "20px", cursor: "pointer", marginRight: "15px"}}
                    onClick={handleClick}
                />
            </OverlayTrigger>
            <div className="dropdown me-2">
            <button
              // onClick={handleExport}
              className=" dropdown-toggle"
              data-bs-toggle="dropdown"
              style={{ fontSize: "16px", border: "none", background: "transparent", color: "#0473ea"}}
            >
              Export
            </button>
            <ul className="dropdown-menu">
              <li>
                <button className="dropdown-item" onClick={exportExcel}>
                  Export as Excel
                </button>
              </li>
              <li>
                <button className="dropdown-item" onClick={exportCSV}>
                  Export as CSV
                </button>
              </li>
            </ul>
            </div>
          </div>
        </div>
        <div
          id="table-data"
          class="flex-wrap"
          style={{ height: "86%", background: "#fff" }}
        >
          <div className='scroll-none-all' ref={ref}>
            <table
              id="data-table"
              class="table table-striped mb-0"
              style={{ border: "3px solid #fff" }}
            >
              <tbody id="table-body">
                <tr style={{ textAlign: "start"}}>
                  <td style={{fontWeight: '600', color: '#000'}}>Entity</td>
                  <td style={{fontWeight: '600', color: '#000'}}>Value</td>
                  <td style={{fontWeight: '600', color: '#000'}} className="text-center">Page No</td>
                </tr>
                {/* {Data && Data?.process_result?.map((res, index) => (
                  <tr
                    id={`${index}-Start`}
                    style={{ textAlign: "start" }}
                    onClick={() =>
                        handleOnClick(res.value, `${index}-Start`, index)
                    }
                  >
                    <td style={{cursor: 'pointer'}}>{res.key}</td>
                    <td style={{cursor: 'pointer'}}>{highlightedRow === index ? (<input style={{width: '100%', border: 'none', color: '#0473ea', background: 'transparent'}} value={res.value} />) : (res.value)}</td>
                    <td style={{width: '90px',cursor: 'pointer'}} className="text-center">{res?.page}</td>
                  </tr>
                ))} */}
                  {rows.map((row, index) => (
                    <tr 
                      key={row.id}
                      id={`${index}-Start`}
                      style={{ textAlign: "start" }}
                      onClick={() =>
                        handleOnClick(row.value, `${index}-Start`, index)
                      }
                    >
                      <td>{row.key?.split(".")?.pop()}</td>
                      <td style={{ cursor: "pointer" }}>
                        {highlightedRow === index ? (
                          <input
                            style={{
                              width: "100%",
                              border: "none",
                              color: "#0473ea",
                              background: "transparent",
                              outline: "none"
                            }}
                            value={row.value}
                            onChange={(e) => {
                              const updatedRows = [...rows];
                              updatedRows[index] = {
                                ...updatedRows[index],
                                value: e.target.value
                              };
                              setRows(updatedRows);
                              setDisabledBtn(false);
                            }}
                          />
                        ) : (
                          row.value
                        )}
                      </td>
                      <td style={{width: '90px',cursor: 'pointer'}} className="text-center">{"1"}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div
            class="d-flex justify-content-between align-items-center px-3"
            style={{
              height: "12%",
              width: "100%",
            //   background: "#E7E7E7",
              fontWeight: "600",
              fontSize: "12px",
            }}
          >
            <p class="text-start mb-0" style={{ color: "#053C77", width: '50%' }}>
             Extract generated: <span>{getFormattedDate()}</span>
            </p>
            <div className='text-end mb-2' style={{width: '50%'}}>
            {/* <button disabled={disabledBtn} className={`${disabledBtn ? 'disabled-blueButton blueButton' : 'blueButton'}`} style={{fontSize: '12px'}}>
                Save
            </button> */}
            <button
              disabled={disabledBtn}
              onClick={handleSave}
              className={`${disabledBtn ? 'disabled-blueButton blueButton' : 'blueButton'}`}
              style={{ fontSize: '12px' }}
            >
              Save
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ResultPage;
